import { render, staticRenderFns } from "./SbolHeader.vue?vue&type=template&id=3f95ecde&scoped=true&"
import script from "./SbolHeader.vue?vue&type=script&lang=js&"
export * from "./SbolHeader.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolHeader.vue?vue&type=style&index=0&id=3f95ecde&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3f95ecde",
  null
  ,true
)

export default component.exports